
import Antd, { message } from 'ant-design-vue';
import dayjs from 'dayjs';
import JsEncrypt from 'jsencrypt';
import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router';
import store from './store';

import request from '@/assets/utils/request';
import Utility from '@/assets/utils/utility';
import 'ant-design-vue/dist/reset.css';
import chTC from './assets/localization/ch-TC.json';
import enUS from './assets/localization/en-US.json';

const app = createApp(App);

app.config.globalProperties.$axios = request;
app.config.globalProperties.$utility = Utility;
app.config.globalProperties.$moment = dayjs;
app.config.globalProperties.$jsEncrypt = JsEncrypt;
app.config.globalProperties.$message = message;

app.use(Antd);

const messages = {
    'ch-TC': chTC,
    'en-US': enUS
};

// 使用 vue-i18n 内置机制,locale 变化自动触发响应式更新
const i18n = createI18n({
    legacy: true,
    locale: 'ch-TC',
    messages: messages
});

// 将 i18n 实例挂载到全局,供非组件代码使用
app.config.globalProperties.$i18n = i18n;

app.use(i18n);
app.use(router);
app.use(store);

// 从 store/localStorage 恢复语言设置,使用 vue-i18n 响应式 API
const savedLocale = store.getters.get_locale_setting;
if (savedLocale && messages[savedLocale]) {
    i18n.global.locale = savedLocale;
}

// 封装 $t 方法为全局属性(兼容旧代码中 this.$t 调用)
// vue-i18n 在 legacy 模式下已自动注册 $t,这里确保可用
// 注意:不要再覆盖 $t,否则会破坏 vue-i18n 的响应式

function getCurrentMediaMatch() {
    var x = window.matchMedia('(max-width: 1240px)');
    console.log('vue3 main.js mounted matchMedia is match：' + x.matches);
    store.dispatch('setNotMobileView', x.matches == false);
}

getCurrentMediaMatch();
window.onresize = () => {
    return (() => {
        getCurrentMediaMatch();
    })();
};

app.mount('#app');
